import React from 'react'

const ChipBreadcrumb = ({ text }: { text: string }) => {
    return (
        <div className='bg-primary-40/10 rounded-xsm w-max'>
            <span className='inline-block text-[0.75rem] leading-[28px] text-primary-10 px-2'>
                {text}
            </span>
        </div>
    )
}

export default ChipBreadcrumb